(() => {
  const selector = '.article > section > h1, .article > section > h2, #produit .product__title h1, #produit .product__description h2, #produit .vf-product-routine h2, #produit .vf-reassurance-title';
  const mobile = window.matchMedia('(max-width: 767px)');
  let frame;
  function lines(title) {
    const range = document.createRange();
    range.selectNodeContents(title);
    return new Set(Array.from(range.getClientRects()).filter(rect => rect.width > 0 && rect.height > 0).map(rect => Math.round(rect.top))).size;
  }
  function fit() {
    document.querySelectorAll(selector).forEach(title => {
      title.style.removeProperty('font-size');
      if (!mobile.matches || !title.getClientRects().length || !title.clientWidth) return;
      let size = parseFloat(getComputedStyle(title).fontSize);
      while (size > 12 && lines(title) > 2) {
        size = Math.max(12, size - 0.5);
        title.style.setProperty('font-size', size + 'px', 'important');
      }
    });
  }
  function schedule() { cancelAnimationFrame(frame); frame = requestAnimationFrame(fit); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, { once: true }); else schedule();
  document.fonts?.ready.then(schedule);
  document.fonts?.addEventListener('loadingdone', schedule);
  window.addEventListener('resize', schedule, { passive: true });
  mobile.addEventListener('change', schedule);
  window.addEventListener('pageshow', schedule);
})();
